import { Component, EventEmitter, Input, Output } from '@angular/core';
import {} from '../../../models/contract-model';
import { ErrorDetail } from '../../models/request-body.interface';

@Component({
    standalone: false,
    selector: 'por-error-dailog-box',
    templateUrl: './error-dailog-box.component.html',
    styleUrls: ['./error-dailog-box.component.scss']
})
export class ErrorDailogBoxComponent {
    @Input() data!: ErrorDetail; // Dynamic message input
    @Input() allowClose = false;
    @Output() readonly retry = new EventEmitter<void>();
    @Output() readonly closeDialog = new EventEmitter<void>();

    onRetryClick(): void {
        this.retry.emit(); // Emit the retry event
    }

    onCloseClick(): void {
        this.closeDialog.emit(); // Emit the onClose event
    }
}
